import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import {
  Autocomplete,
  Avatar,
  Box,
  Chip,
  TextField,
  Typography,
} from "@mui/material";
import { loadAutoCompleteUsers } from "../../pages/app/utils/dataLoader";

const getLastName = (str) => str.split(" ")[str.split(" ").length - 1];

export const CaseViewers = ({ control, name, readOnly }) => {
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    const load = async () => {
      const autocompleteUsers = await loadAutoCompleteUsers();
      if (!autocompleteUsers) console.error("Error loading autocompleteUsers");
      setUserList(autocompleteUsers || []);
    };
    load();
  }, []);

  const formattedSortedAllUsers = userList.sort((a, b) =>
    getLastName(a.label).localeCompare(getLastName(b.label)),
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value = [] } }) => {
        const selectedUsers = Array.isArray(value) ? value : [];
        const filteredSortedSelectedUsers = selectedUsers
          .filter(
            (user1, index, arr) =>
              arr.findIndex((user2) => user2.key === user1.key) === index,
          )
          .sort((a, b) =>
            getLastName(a.label).localeCompare(getLastName(b.label)),
          );

        const handleAddUser = (_, newValue) => {
          if (newValue) {
            const updated = [...selectedUsers, newValue];
            onChange(updated);
          }
        };

        const handleChipDelete = (chipToDelete) => {
          const updated = selectedUsers.filter(
            (u) => u.key !== chipToDelete.key,
          );
          onChange(updated);
        };

        return (
          <>
            <Box>
              <Typography variant="caption">SPECIFIC USERS</Typography>
            </Box>
            {!readOnly && (
              <Autocomplete
                disablePortal
                isOptionEqualToValue={(option, val) => option.key === val?.key}
                onChange={handleAddUser}
                options={formattedSortedAllUsers}
                sx={{ width: { xs: 1, sm: "calc(50% - 1rem)" } }}
                renderInput={(params) => <TextField {...params} />}
              />
            )}
            {filteredSortedSelectedUsers.length > 0 && (
              <Box display="flex" flexWrap="wrap" gap={1} mt={2}>
                {filteredSortedSelectedUsers.map((user) => (
                  <Chip
                    color="primary"
                    variant="outlined"
                    key={user.key}
                    avatar={<Avatar>{user.avatar}</Avatar>}
                    label={user.label}
                    onDelete={
                      !readOnly ? () => handleChipDelete(user) : undefined
                    }
                  />
                ))}
              </Box>
            )}
          </>
        );
      }}
    />
  );
};
